<template>
	<div style="width:560px; height:450px;" v-on:keyup.esc="close()">
		<table class="view_tbl" border="0">
			<colgroup>
				<col style="width:120px;" />
				<col style="" />
			</colgroup>
			<tbody>
				<tr>
					<th>Receipt Date</th>
					<td><CustomDatePicker v-model="receipt_item.receipt_date" /></td>
				</tr>
				<tr>
					<th>Payment Method</th>
					<td class="al_left">
						<select v-model="receipt_item.receipt_type" class="tbl_select mm_int">
							<option v-for="receiptType in receiptTypes" v-bind:value="{ code: receiptType.code, name: receiptType.name }" v-bind:key="receiptType.code">{{ receiptType.name }}</option>
						</select>
					</td>
				</tr>
				<tr v-show="postCheck(receipt_item.receipt_type)">
					<th>Post Check Date</th>
					<td><CustomDatePicker v-model="receipt_item.post_check_date" /></td>
				</tr>
				<tr>
					<td colspan="2"><input type="text" class="r_int long_type al_left" v-model="receipt_item.check_no" placeholder="Check No or Pay Info." autocomplete="off" @focus="$event.target.select()" /></td>
				</tr>
			</tbody>
		</table>

		<div class="view_inner">
			<br />

			<div class="view_bottom_bt" style="padding-top:20px;">
				<a href="javascript:;" type="button" class="search_bt" @click="save()">Save</a>
				<a href="javascript:;" type="button" class="gray_bt" @click="close()">Cancel</a>
			</div>
		</div>
	</div>
</template>

<script>
import '@/assets/css/table_box.css';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import { apiIndex, apiUpdateReceiptMethod } from '@/api/receipt/index.js';
import { today, isDate } from '@/utils/date.js';

export default {
	data: function() {
		return {
			receipt_item: {},

			receiptTypes: [],
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : '';
		},

		// toReceiveInvoices: function() {
		// 	return this.invoices.filter(invoice => invoice.selected && invoice.pay_amount);
		// },
	},
	props: {
		prop_receipt_item: Object,
	},
	components: {
		CustomDatePicker,
	},
	watch: {},
	methods: {
		close() {
			this.$emit('close');
		},
		postCheck(receipt_type) {
			if (receipt_type && receipt_type.name.toUpperCase().indexOf('POST') >= 0) {
				this.receipt_item.post_check_yn = 'Y';
				return true;
			} else {
				this.receipt_item.post_check_yn = 'N';
				return false;
			}
		},
		async save() {
			if (!this.receipt_item.receipt_date || !isDate(this.receipt_item.receipt_date)) {
				this.$toast.error('Invalid receipt date');
				return;
			}

			if (!this.receipt_item.receipt_type) {
				this.$toast.error('Select payment method.');
				return;
			}

			if (this.receipt_item.receipt_type.name.toUpperCase().indexOf('CHECK') >= 0 && !this.receipt_item.check_no) {
				this.$toast.error('Check no is empty.');
				return;
			}

			this.receipt_item.receipt_item_no = this.prop_receipt_item.receipt_item_no;
			this.receipt_item.receipt_no = this.prop_receipt_item.receipt_no;

			// post check라면, 기존 데이터, 아니라면, 1로 valid 설정하기
			if (this.receipt_item.post_check_yn == 'Y') {
				if (!this.receipt_item.post_check_date || !isDate(this.receipt_item.post_check_date)) {
					this.$toast.error('Invalid post check date');
					return;
				}

				this.receipt_item.valid_receipt_date = this.receipt_item.post_check_date;
				this.receipt_item.valid = this.prop_receipt_item.valid;
			} else {
				this.receipt_item.valid_receipt_date = this.receipt_item.receipt_date;
				this.receipt_item.valid = 1;
			}

			//console.log(this.receipt_item);
			//var dummy = 1;
			//if (dummy) return;

			const { data } = await apiUpdateReceiptMethod(this.receipt_item);

			if (data.result) {
				this.$toast.success('Updated successfully');
				this.$emit('receipt-item-call-back', true);
				this.close();
			} else {
				this.$toast.error(data.msg);
			}
		},

		async init() {
			const { data } = await apiIndex();

			//this.receiptTypes = data.receiptTypeList.filter(t => t.name.toUpperCase().indexOf('POST') < 0);
			this.receiptTypes = data.receiptTypeList;
			//console.log(this.receiptTypes);
		},
	},
	created() {
		this.init();

		this.receipt_item.receipt_date = today();
		this.receipt_item.check_no = this.prop_receipt_item.check_no;
		//console.log(this.prop_receipt_item);
	},
};
</script>

<style></style>
